export const termsCopy = {
    en: {
        title: "Terms & Conditions",
        eyebrow: "LARIVA — Italian Lakes Collection",
        updated: "Last updated: July 2026",
        intro: "These Terms & Conditions govern the use of the LARIVA website (larivacomo.com), a brand presentation and business enquiry website. By using this website, you accept these Terms.",
        sections: [
            {
                n: "01",
                h: "Website Purpose",
                p: [
                    "This website presents LARIVA – Italian Lakes Collection, a premium Italian mineral water collection inspired by the elegance of the Italian lakes, and allows selected hospitality operators and potential business partners to contact us.",
                    "The website is informational in nature. It is not an e-commerce website: it offers no online purchases, no payments, no customer accounts and no subscriptions.",
                ],
            },
            {
                n: "02",
                h: "Intellectual Property",
                p: [
                    "The LARIVA name, the LAKE COMO COLLECTION designation, the emblem, logos, texts, images, graphics and overall design of this website are protected intellectual property. They may not be reproduced, distributed or used in any way without prior written permission.",
                ],
            },
            {
                n: "03",
                h: "Content & Product Representations",
                p: [
                    "Website content is prepared with care. Product images, packaging concepts and specifications are shown for presentation purposes and may evolve before final commercial production. Images are illustrative and may differ from the final marketed product.",
                ],
            },
            {
                n: "04",
                h: "No Online Sale or Contractual Offer",
                p: [
                    "Nothing on this website constitutes a binding offer. No contract is concluded through the website, and no prices, availability or delivery conditions are stated or implied.",
                ],
            },
            {
                n: "05",
                h: "Request Access Enquiries",
                p: [
                    "Submitting the Request Access form is a non-binding expression of interest. It does not create a contract, nor does it guarantee commercial availability, pricing, delivery or the conclusion of any partnership. Any commercial relationship is subject to a separate written agreement.",
                ],
            },
            {
                n: "06",
                h: "Accuracy & Availability",
                p: [
                    "We make reasonable efforts to keep the website accurate and available, but we do not warrant that all content is complete, error-free or that the website will be uninterrupted. Content may be updated, modified or suspended at any time.",
                ],
            },
            {
                n: "07",
                h: "External Links",
                p: [
                    "This website may contain links to external websites or social media profiles. We are not responsible for the content or practices of third-party websites.",
                ],
            },
            {
                n: "08",
                h: "Privacy",
                p: [
                    "Personal data collected through this website is handled in accordance with our Privacy Policy, available on this website.",
                ],
            },
            {
                n: "09",
                h: "Website Operator",
                p: [
                    "This website is operated by:",
                    "NEST SAGL\nVia San Giorgio 29\n6834 Morbio Inferiore\nSwitzerland\nSwiss UID: CHE-454.536.077",
                    "Contact: hello@larivacomo.com",
                ],
            },
            {
                n: "10",
                h: "Governing Law & Jurisdiction",
                p: [
                    "These Terms are governed by Swiss law. The courts at the registered office of the website operator shall have jurisdiction, subject to mandatory provisions of applicable law.",
                ],
            },
        ],
        back: "Back to larivacomo.com",
    },
    it: {
        title: "Termini e Condizioni",
        eyebrow: "LARIVA — Italian Lakes Collection",
        updated: "Ultimo aggiornamento: luglio 2026",
        intro: "I presenti Termini e Condizioni regolano l'uso del sito LARIVA (larivacomo.com), un sito di presentazione del brand e di richieste commerciali. Utilizzando questo sito, accetti i presenti Termini.",
        sections: [
            {
                n: "01",
                h: "Finalità del Sito",
                p: [
                    "Questo sito presenta LARIVA – Italian Lakes Collection, una collezione premium di acqua minerale italiana ispirata all'eleganza dei laghi italiani, e consente a operatori hospitality selezionati e potenziali partner commerciali di contattarci.",
                    "Il sito ha natura esclusivamente informativa. Non è un sito e-commerce: non offre acquisti online, pagamenti, account cliente né abbonamenti.",
                ],
            },
            {
                n: "02",
                h: "Proprietà Intellettuale",
                p: [
                    "Il nome LARIVA, la denominazione LAKE COMO COLLECTION, l'emblema, i loghi, i testi, le immagini, la grafica e il design complessivo di questo sito sono proprietà intellettuale protetta. Non possono essere riprodotti, distribuiti o utilizzati in alcun modo senza previa autorizzazione scritta.",
                ],
            },
            {
                n: "03",
                h: "Contenuti e Rappresentazioni dei Prodotti",
                p: [
                    "I contenuti del sito sono preparati con cura. Le immagini dei prodotti, i concept di packaging e le specifiche sono presentati a scopo illustrativo e possono evolvere prima della produzione commerciale finale. Le immagini possono differire dal prodotto finale commercializzato.",
                ],
            },
            {
                n: "04",
                h: "Nessuna Vendita Online né Offerta Contrattuale",
                p: [
                    "Nulla in questo sito costituisce un'offerta vincolante. Nessun contratto viene concluso attraverso il sito e non vengono indicati né sottintesi prezzi, disponibilità o condizioni di consegna.",
                ],
            },
            {
                n: "05",
                h: "Richieste tramite il Modulo",
                p: [
                    "L'invio del modulo Richiedi Accesso costituisce una manifestazione di interesse non vincolante. Non crea alcun contratto né garantisce disponibilità commerciale, prezzi, consegne o la conclusione di partnership. Qualsiasi rapporto commerciale è soggetto a un separato accordo scritto.",
                ],
            },
            {
                n: "06",
                h: "Accuratezza e Disponibilità",
                p: [
                    "Ci impegniamo ragionevolmente a mantenere il sito accurato e disponibile, ma non garantiamo che tutti i contenuti siano completi, privi di errori o che il sito sia sempre accessibile. I contenuti possono essere aggiornati, modificati o sospesi in qualsiasi momento.",
                ],
            },
            {
                n: "07",
                h: "Link Esterni",
                p: [
                    "Questo sito può contenere collegamenti a siti esterni o profili social. Non siamo responsabili dei contenuti o delle pratiche di siti di terze parti.",
                ],
            },
            {
                n: "08",
                h: "Privacy",
                p: [
                    "I dati personali raccolti attraverso questo sito sono trattati in conformità con la nostra Privacy Policy, disponibile su questo sito.",
                ],
            },
            {
                n: "09",
                h: "Gestore del Sito",
                p: [
                    "Questo sito è gestito da:",
                    "NEST SAGL\nVia San Giorgio 29\n6834 Morbio Inferiore\nSvizzera\nUID svizzera: CHE-454.536.077",
                    "Contatto: hello@larivacomo.com",
                ],
            },
            {
                n: "10",
                h: "Legge Applicabile e Foro Competente",
                p: [
                    "I presenti Termini sono regolati dal diritto svizzero. È competente il foro presso la sede del gestore del sito, fatte salve le disposizioni imperative di legge applicabili.",
                ],
            },
        ],
        back: "Torna a larivacomo.com",
    },
};
